import React from 'react';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs';
import { Back, PreviewSection } from '../styled/ProjectPreview.styled';

const ProjectPreview = ({ project,setProject }) => {
    return (
        <PreviewSection>
            <Back onClick={()=>(setProject(null))}>
                <BsFillArrowLeftCircleFill />
            </Back>
            <h4>{`${project.name} - Preview`}</h4>
            <img className='w-100' src={project.image} />
        </PreviewSection>
    );
};

export default ProjectPreview;